var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.items.length > 0)?_c('div',{staticClass:"newly-added"},[_c('h2',[_vm._v("Newly Added")]),_c('div',{staticClass:"item-list"},_vm._l((_vm.items),function(item){return _c('Item',{key:item,attrs:{"item":item}})}),1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }